<template>
  <div class="button-container" :class="data.buttonList && data.buttonList.length?'':'no_data'">

    <el-button-group class="buttonGroup">
      <template v-for="(button, index) in data.buttonList">
        <!-- 按钮下拉组 -->
        <template v-if="button.items && button.items.length > 0">
          <el-popover trigger="click" :width="calculatePopoverWidth(button.items)" :type="button.className" size="large" :plain="!button.isPlain">
            <template #reference>
              <el-button :type="button.className" size="large" :icon="button.icon" :plain="!button.isPlain" :class="{
                'single-button-group': data.buttonList.length === 1 && !button.isPlain && button.className == 'primary',
                'border-danger': data.buttonList.length === 1 && !button.isPlain && button.className == 'danger',
                'border-info': data.buttonList.length === 1 && !button.isPlain && button.className == 'info',
                'border-warning': data.buttonList.length === 1 && !button.isPlain && button.className == 'warning',
                'border-success': data.buttonList.length === 1 && !button.isPlain && button.className == 'success',
              }">
                {{ button.name }}
              </el-button>
            </template>

            <div class="button-grid">
              <el-button class="btn-item" text v-for="(btnChild, childIndex) in button.items" :key="childIndex"
                :command="btnChild.order" @click="handleClick(btnChild)" :icon="btnChild.icon" :class="getRightBorderClass(childIndex, button.items.length)">
                <el-tooltip :hide-after="0" :content="btnChild.tip || btnChild.name" :disabled="!btnChild.tip && !btnChild.name" placement="top">
                  <span class="btn-text">{{ btnChild.name }}</span>
                </el-tooltip>
              </el-button>
            </div>

          </el-popover>
        </template>
        <!-- 单按钮 -->
        <template v-else>

          <el-tooltip :hide-after="0" v-if="button.tip" :content="button.tip" placement="top">
            <el-button :key="index" :plain="!button.isPlain" :type="button.className" :icon="button.icon"
              @click="handleClick(button)" size="large" :disabled="data.isLoading && data.btnName == button.eventName"
              :loading="data.isLoading && data.btnName == button.eventName" :class="{
                'single-button-group': data.buttonList.length === 1 && !button.isPlain && button.className == 'primary',
                'border-danger': data.buttonList.length === 1 && !button.isPlain && button.className == 'danger',
                'border-info': data.buttonList.length === 1 && !button.isPlain && button.className == 'info',
                'border-warning': data.buttonList.length === 1 && !button.isPlain && button.className == 'warning',
                'border-success': data.buttonList.length === 1 && !button.isPlain && button.className == 'success',
              }">
              {{ data.isLoading && data.btnName == button.eventName?'加载中':button.name }}
            </el-button>
          </el-tooltip>
          <el-button v-else :key="index" :plain="!button.isPlain" :type="button.className" :icon="button.icon"
            @click="handleClick(button)" size="large" :disabled="data.isLoading && data.btnName == button.eventName"
            :loading="data.isLoading && data.btnName == button.eventName" :class="{
              'single-button-group': data.buttonList.length === 1 && !button.isPlain && button.className == 'primary',
              'border-danger': data.buttonList.length === 1 && !button.isPlain && button.className == 'danger',
              'border-info': data.buttonList.length === 1 && !button.isPlain && button.className == 'info',
              'border-warning': data.buttonList.length === 1 && !button.isPlain && button.className == 'warning',
              'border-success': data.buttonList.length === 1 && !button.isPlain && button.className == 'success',
            }">
            {{ data.isLoading && data.btnName == button.eventName?'加载中':button.name }}
          </el-button>
        </template>
      </template>
    </el-button-group>
  </div>
</template>

<script setup>
  import {
    ref,
    reactive,
    toRefs,
    defineProps,
    onBeforeMount,
    watch,
    getCurrentInstance,
    nextTick
  } from "vue";
  import { GetTheMenuButtons, GetTheMenuButtonsStudent } from "@/network/public";

  // 计算 popover 宽度
  const calculatePopoverWidth = (items) => {
    if (!items || !items.length) return 400;
    if (items.length < 5) return 260; // 只有一列时宽度更小
    if (items.length < 11) return 450; // 两列
    const buttonsPerColumn = items.length > 11 ? 3 : 2;
    const columnWidth = 220;
    const columns = Math.ceil(items.length / buttonsPerColumn);
    const totalWidth = Math.max(400, columns * columnWidth);
    return Math.min(totalWidth, 680);
  };

  onBeforeMount(async () => {
    await getOperationList();
  });
  const props = defineProps({
    buttons: {},
    isLoading: {},
    btnName: {},
    isCustomStudent: {
      type: Boolean,
      default: false
    }
  });
  const emit = defineEmits(["btn-handle", "btn-in-table", 'btn-on-left']);
  const tableRef = ref(null);
  const data = reactive({
    buttonList: props.buttons,
    isLoading: false,
    btnName: '',
    buttonNew: [],
  });

  watch(
    () => props,
    (newVal) => {
      data.isLoading = props.isLoading;
      data.btnName = props.btnName;
    },
    {
      deep: true,
      immediate: true,
    }
  );

  const handleClick = (button) => {
    emit("btn-handle", button?.eventName);
  };
  const getOperationList = async () => {
    const tabObj = sessionStorage.getItem("tabObj")
      ? JSON.parse(sessionStorage.getItem("tabObj"))
      : {};
    let studentPageId = tabObj.studentPageId || tabObj.params?.studentPageId;
    let res;
    if (props.isCustomStudent) {
      // 定制化学员列表页单独调接口
      res = await GetTheMenuButtonsStudent({ pageId: studentPageId });
    } else {
      res = await GetTheMenuButtons(tabObj.id, true, studentPageId);
    }

    let arr = res.result || [];
    data.buttonList = arr.filter((item) => !item.isInTable);
    data.buttonNew = arr.filter((item) => item.isInTable);
    setInnerButtonListSession(tabObj)

    emit("btn-in-table", data.buttonNew);
    emit("btn-on-left", data.buttonList);
    sessionStorage.setItem("buttonList", JSON.stringify(data.buttonList));
  };
  // 保存动态列表按钮
  function setInnerButtonListSession(tabObj) {
    const buttonList = JSON.parse(sessionStorage.getItem("innerButtonLists")) || {}
    buttonList[tabObj.id] = data.buttonNew;
    sessionStorage.setItem("innerButtonLists", JSON.stringify(buttonList));
    const sessionStorageChangeEvent = new Event('buttonSessionStorageChange');
    window.dispatchEvent(sessionStorageChangeEvent);
  }

  const getRightBorderClass = (index, total) => {
    if (total < 5) return 'no-right-border'; // 一行时全部无右边框
    const columns = total > 10 ? 3 : 2;
    return ((index + 1) % columns === 0) ? 'no-right-border' : '';
  };
</script>
<style scoped>
  /* // 引入 element-ui 的主题变量 */
  @import url("./css/index.scss");

  .button-container {
    display: inline-block;
    vertical-align: top;
  }

  .button-grid {
    display: grid;
    gap: 8px;
    width: 100%;
    grid-template-columns: repeat(1, minmax(120px, 1fr));
    padding-right: 13px;
  }

  .button-grid:has(.btn-item:nth-child(n+5)) {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }

  .button-grid:has(.btn-item:nth-child(n+11)) {
    grid-template-columns: repeat(3, minmax(120px, 1fr));
  }

  ::v-deep .single-button-group {
    border: 1px solid var(--el-color-primary) !important;
    /* 可以使用 CSS 变量或固定值 */
    border-radius: 4px;
    /* 可根据需要调整 */
  }

  ::v-deep .border-danger {
    border: 1px solid var(--el-color-danger) !important;
  }

  ::v-deep .border-info {
    border: 1px solid var(--el-color-info) !important;
  }

  ::v-deep .border-warning {
    border: 1px solid var(--el-color-warning) !important;
  }

  ::v-deep .border-success {
    border: 1px solid var(--el-color-success) !important;
  }

  .btn-item {
    justify-content: flex-start;
    text-align: left;
    margin: 0;
    width: 105%;
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #ebeef5;
    padding: 22px 10px;
    border-right: 1px solid #ebeef5;
    box-sizing: border-box;
    margin-top: -8px;
  }

  .btn-item.no-right-border {
    border-right: none;
  }

  .btn-text {
    /* 让按钮内容不换行，超出省略号 */
    display: inline-block;
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .no_data {
    height: 0 !important;
  }
</style>